import { KIND, SIZE } from 'baseui/button'
import SDButton from '@/shared/components/SDComponents/SDButton/SDButton'
import { OuterContainer, Block, BlockTitle } from '../styled-components'
import useComparatorIndex from './useComparatorIndex'

const ComparatorIndex = () => {
  const { t, comparators, handleAdd, isSelectraAdmin } = useComparatorIndex()

  if (!isSelectraAdmin) {
    return <OuterContainer><Block>{t('comparator.unauthorized')}</Block></OuterContainer>
  }

  return (
    <OuterContainer>
      <Block>
        <BlockTitle>{t('comparator.title')}</BlockTitle>
        <SDButton onClick={handleAdd} size={SIZE.mini} kind={KIND.secondary}>
          {t('comparator.add_btn')}
        </SDButton>
        <table style={{ width: '100%', marginTop: '1rem', borderCollapse: 'collapse' }}>
          <thead>
            <tr>
              <th style={{ textAlign: 'left', padding: '0.5rem', borderBottom: '1px solid #ccc' }}>{t('name')}</th>
              <th style={{ textAlign: 'left', padding: '0.5rem', borderBottom: '1px solid #ccc' }}>{t('uuid')}</th>
            </tr>
          </thead>
          <tbody>
            {comparators.map(comparator => (
              <tr key={comparator.id ?? comparator.uuid ?? comparator.name}>
                <td style={{ padding: '0.5rem', borderBottom: '1px solid #eee' }}>{comparator.name}</td>
                <td style={{ padding: '0.5rem', borderBottom: '1px solid #eee' }}>{comparator.uuid}</td>
              </tr>
            ))}
            {comparators.length === 0 && (
              <tr>
                <td colSpan={2} style={{ padding: '0.5rem', color: '#999' }}>
                  {t('comparator.empty')}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </Block>
    </OuterContainer>
  )
}

export default ComparatorIndex
